import { ApolloClient as ReactApolloClient, InMemoryCache } from '@apollo/client';
import config from 'commons-general/config/index.js';
import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';

class ApolloClient {
    _create() {
        this.client = new ReactApolloClient({
            connectToDevTools: !!WindowProxy.get(),
            uri: config.endpoint.graphql,
            headers: {
                'accept-language': LocaleService.getLocale(),
            },
            partialResultsOnError: true,
            cache: new InMemoryCache(),
        });

        return this.client;
    }

    /**
     * Initialize an Apollo Client or return it if it's aleady initialized
     * @returns {ApolloClient}
     */
    getOrCreate() {
        return this.client || this._create();
    }
}

export { ReactApolloClient };

export default new ApolloClient();
